"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.m = void 0;
const tslib_1 = require("tslib");
const hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
exports.m = hyperscript_1.default;
//# sourceMappingURL=mithril.js.map